/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckOnboarding200Response
 */
export interface CheckOnboarding200Response {
    /**
     * 
     * @type {boolean}
     * @memberof CheckOnboarding200Response
     */
    success?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckOnboarding200Response
     */
    isOnboardingComplete?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckOnboarding200Response
     */
    requiresOnboarding?: boolean;
}

/**
 * Check if a given object implements the CheckOnboarding200Response interface.
 */
export function instanceOfCheckOnboarding200Response(value: object): value is CheckOnboarding200Response {
    return true;
}

export function CheckOnboarding200ResponseFromJSON(json: any): CheckOnboarding200Response {
    return CheckOnboarding200ResponseFromJSONTyped(json, false);
}

export function CheckOnboarding200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckOnboarding200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'isOnboardingComplete': json['isOnboardingComplete'] == null ? undefined : json['isOnboardingComplete'],
        'requiresOnboarding': json['requiresOnboarding'] == null ? undefined : json['requiresOnboarding'],
    };
}

export function CheckOnboarding200ResponseToJSON(json: any): CheckOnboarding200Response {
    return CheckOnboarding200ResponseToJSONTyped(json, false);
}

export function CheckOnboarding200ResponseToJSONTyped(value?: CheckOnboarding200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'isOnboardingComplete': value['isOnboardingComplete'],
        'requiresOnboarding': value['requiresOnboarding'],
    };
}

